import { Box } from '@mui/material'
import 'flag-icons/css/flag-icons.min.css'
import { tokens } from '../theme'

/**
 * The flag for an ISO 3166-1 alpha-2 code.
 *
 * An SVG, not an emoji. Emoji flags are pairs of regional indicator
 * codepoints and only become a flag if the font carries the glyph —
 * Windows ships none, so every one degrades to its two letters.
 *
 * Decoration, and hidden from assistive technology: the country's name is
 * always beside it.
 */
export function Flag({ code, size = 15 }: { code: string | null | undefined; size?: number }) {
  const known = Boolean(code) && /^[A-Z]{2}$/.test(code!) && !NO_FLAG.has(code!)
  return (
    <Box
      aria-hidden
      className={known ? `fi fi-${code!.toLowerCase()}` : undefined}
      sx={{
        width: Math.round(size * 4 / 3), height: size, flex: 'none', borderRadius: '2px',
        // A hairline, so a mostly-white flag still reads as a rectangle
        // rather than dissolving into the row behind it.
        boxShadow: known ? `inset 0 0 0 1px ${tokens.color.ink200}` : 'none',
        backgroundSize: 'cover',
      }}
    />
  )
}

/** In the boundary data, but not countries with flags of their own. */
const NO_FLAG = new Set(['XK', 'XD', 'XA', 'XB', 'XC', 'XE', 'XF', 'XG', 'XH', 'XI'])
